import { useState } from "react";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { apiClient } from "@/lib/api";
import { toast } from "sonner";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post("/newsletter", { email });
      toast.success("You're subscribed to our research updates.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-600" data-testid="newsletter-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <Mail className="h-8 w-8 text-white/80 mx-auto mb-5" strokeWidth={1.5} />
        <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-white font-display">Stay Ahead in Peptide Research</h2>
        <p className="mt-4 text-blue-100 text-base">Subscribe for updates on new research compounds, batch documentation, and laboratory insights.</p>
        <form onSubmit={handleSubmit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="home-newsletter-form">
          <input
            type="email"
            required
            placeholder="Research email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 rounded-full px-5 py-3 text-sm border-0 focus:outline-none focus:ring-2 focus:ring-white"
            data-testid="home-newsletter-input"
          />
          <Button type="submit" disabled={loading} className="rounded-full bg-white text-slate-900 hover:bg-slate-100 px-6" data-testid="home-newsletter-submit">
            Subscribe
          </Button>
        </form>
      </div>
    </section>
  );
}
